import { useEffect, useState } from "react";
import { LowerBracket } from "../../../interfaces/api/LowerBracket";
import { Rototilt } from "../../../interfaces/api/Rototilt";
import { ProductCategory } from "../../../shared/enums/ProductCategory";
import { WizardStepIndex } from "../../../shared/enums/WizardStep";
import { useCartProduct } from "../../../store/hooks/useCartProduct";
import { useProduct } from "../../../store/hooks/useProduct";
import { useWizard } from "../../../store/hooks/useWizard";

export const useSelectedLowerBracketAndTiltrotator = () => {
  const product = useProduct();
  const wizard = useWizard();
  const cartProduct = useCartProduct();
  const [selectedLowerBracket, setSelectedLowerBracket] =
    useState<LowerBracket>(undefined);
  const [selectedTiltrotator, setSelectedTiltrotator] =
    useState<Rototilt>(undefined);

  useEffect(() => {
    const lowerBracket =
      product.productCategory === ProductCategory.Tiltrotator &&
      wizard.activeStepIndex === WizardStepIndex.Optional
        ? cartProduct?.lowerBracket
        : undefined;

    setSelectedLowerBracket(lowerBracket);
    const tiltrotator =
      product.productCategory === ProductCategory.Tiltrotator &&
      wizard.activeStepIndex === WizardStepIndex.Optional
        ? cartProduct?.tiltrotator
        : undefined;

    setSelectedTiltrotator(tiltrotator);
  }, [
    cartProduct?.lowerBracket,
    cartProduct?.tiltrotator,
    product.productCategory,
    wizard.activeStepIndex,
  ]);

  return { selectedLowerBracket, selectedTiltrotator };
};
